import { css } from '@emotion/core'
import React from 'react'
import ImagePicker from './InnerComponents/ImagePicker/ImagePicker'
import TextPicker from './InnerComponents/TextPicker/TextPicker'
import { StoryProvider } from '../../providers/StoryProvider'

const layoutCSS = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0px, 1fr));
  grid-template-rows: repeat(2, minmax(0px, 1fr));
  height: 100%;
  width: 100%;
  gap: 30px;
  position: relative;
`

const getComponentFromType = (isPrintView, type, pageNumber, size, index, props) => {
  switch (type) {
    case 'image':
      return <ImagePicker pageNumber={pageNumber} positionIndex={index} isPrintView={isPrintView} {...props} />
    case 'text':
      return (
        <StoryProvider>
          <TextPicker size={size} pageNumber={pageNumber} positionIndex={index} isPrintView={isPrintView} {...props} />
        </StoryProvider>
      )
    default:
      return null
  }
}

const getGridAreaStyle = (size) => {
  switch (size) {
    case 'quarter':
      return 'span 1 / span 1'
    case 'half':
      return 'span 1 / span 2'
    case 'full':
      return 'span 2 / span 2'
    default:
      return 'span 1 / span 1'
  }
}

const PageAssembler = ({ assemblyInstructions, pageNumber, isPrintView = false }) => {
  return (
    <div css={layoutCSS}>
      {Array.isArray(assemblyInstructions) &&
        assemblyInstructions.map((item, index) => {
          const uniqueKey = `${item.type}-${pageNumber}-${index}-${item.props?.memoryId}`

          return (
            <div key={uniqueKey} style={{ gridArea: getGridAreaStyle(item.size) }}>
              {getComponentFromType(isPrintView, item.type, pageNumber, item.size, index, item.props)}
            </div>
          )
        })}
    </div>
  )
}

export default PageAssembler
